/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('ArchivedInfosCtrl', function($scope, identity, Informations, ErrorThrower) {
    const errorManager = new ErrorThrower;

    return identity
    .$promise
    .then(function(me) {
        $scope.me = me;
        return Informations
        .queryAll({
            login: me.login})
        .$promise
        .then(archived_infos => $scope.archived_infos = archived_infos).catch(error => errorManager.minor('Une erreur est survenue lors de la récupération de vos informations'));
    });
});
